<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.jornadaBloqueio"
        ref="RkmDataTable"
    >
        <template v-slot:cell(usuarioNome)="{ value }">
            {{ value || 'TODOS' }}
        </template>

        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click="handleEdit(item.id)"
                authorize="edit-exame-laboratorial-jornada-bloqueio"
                color="primary"
                small
                title="Editar"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click="handleDestroy(item)"
                authorize="destroy-exame-laboratorial-jornada-bloqueio"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import {error, repository} from '@/mixins'

export default {
    created() {
        this.repositories = {
            jornadaBloqueio: this.getConectaSusRepository('exameLaboratorial.jornadaBloqueio'),
        }
    },
    data: () => ({
        fields: [
            {
                key: 'unidadeNomeFantasia',
                label: 'Unidade',
                name: 'unidade.nomeFantasia',
                searchable: true,
                sortable: true,
            },
            {
                key: 'infraestruturaNome',
                label: 'Local de atendimento',
                name: 'infraestrutura.nome',
                searchable: true,
                sortable: true,
            },
            {
                key: 'inicio',
                label: 'Início',
                name: 'jornadaBloqueio.inicio',
                searchable: true,
                sortable: true,
            },
            {
                key: 'fim',
                label: 'Fim',
                name: 'jornadaBloqueio.fim',
                searchable: true,
                sortable: true,
            },
            {
                class: 'col-min',
                key: 'actions',
                label: 'Ações',
            },
        ],
    }),
    methods: {
        handleEdit(id) {
            this.$router.push({name: 'exame-laboratorial-jornada-bloqueio-edit', params: {id}})
        },
        handleDestroy(item) {
            const destroy = () => this.repositories.jornadaBloqueio.destroy(item.id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o bloqueio de jornada?', destroy)
        },
    },
    mixins: [error, repository],
}
</script>